//recaptcha google v3
$('.houdiniForm').submit(function(event) {
  //console.log(RECAPTCHA_SITE_KEY);
  event.preventDefault();
  var form = $(this);

  form.validate();
  var isFormValid =form.valid();

  if (isFormValid) {
      event.preventDefault();
      grecaptcha.ready(function() {
          grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'formsubmit'}).then(function(token) {
              form.prepend('<input type="hidden" name="token" value="' + token + '">');
              form.prepend('<input type="hidden" name="action" value="formsubmit">');
              form.unbind('submit').submit();
          });;
      });
  }
});

$(document).on("input", "input:file", function(e) {
    let fileName = e.target.files[0].name;
    $(this).parents('.file').find('.file-add').remove();
    $('<span class="file-add file-cta ml-2">'+fileName+'</span>').insertAfter($(this).parent())


});
